<template>
  <modal-template :title="$t('airbnb.BuscarAlojamiento')"
                  class="airbnb-modal"
                  @close="$emit('closeAirbnb')">
    <div class="container-airbnb-modal">
      <iframe :src="getAccommodationUrl()"
              :title="$t('airbnb.BuscarAlojamiento')"
              frameborder="noborder"
              style="width: 100%; height: 99%;" />
    </div>
  </modal-template>

</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  props: {
    accommodation: {
      type: Object,
      default: () => {}
    },
    place: {
      type: String,
      default: 'aid=wegow-event'
    }
  },
  methods: {
    getAccommodationUrl() {
      return this.accommodation.url.replace('aid=wegow', this.place)
    }
  }
}
</script>
<style lang="scss">
#wegow-default-styles {
  .airbnb-modal {
    .container-airbnb-modal {
      height: 100vh;
      @media screen and (min-width: $screen-sm) {
        height: calc(100vh - 280px);
      }
    }
  }
}
</style>
